import { useState, useEffect } from "react";
import { playerRequests } from "../../request/requests";

export default function Ranking() {

    const [players, setPlayers] = useState([]);
    const [search, setSearch] = useState('');

    const loadPlayers = async () => {
        const res = await playerRequests.getPlayers();
        if(res.success){
            setPlayers(res.data.sort((a, b) => b.score - a.score));
        }
    };

    useEffect(() => {
        loadPlayers();
    }, []);
    
    return (
        <div style={{margin: 'auto', textAlign: 'center'}}>
            {/* Back Button */}
            <div 
                onClick={() => { window.history.back(); }}
                style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px',
                    width: '35px',
                    height: '35px',
                    borderRadius: '50%',
                    backgroundColor: '#fff',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
                    cursor: 'pointer',
                    zIndex: 3000
                }}
                >
                <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path 
                    d="M19 12H5M5 12L12 19M5 12L12 5" 
                    stroke="#004A7C" 
                    strokeWidth="2.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    />
                </svg>
            </div>
            <img alt="" width={'100%'} style={{position: 'relative', top: 0, left: 0}} src="./assets/header-welcome.png" />
            <div style={{background: '#FBB900', color: '#004A7C', padding: '8px', textAlign: 'center', fontSize: '0.9rem', fontWeight: '400', textTransform:"uppercase"}}>
                Explore Europe with Haribo!
            </div>
            <div style={{padding: '0.5rem 0.5rem 3rem 0.5rem', height: '60vh',textAlign: 'center', position: 'fixed', width: '100vw', background: 'linear-gradient(180deg, #FFFFFF 0%, #FFF4AA 50%, #FFDB00 100%)', overflowY: 'scroll', zIndex: 0,    scrollbarWidth: 'none', msOverflowStyle: 'none',}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', background: 'rgba(255,255,255,0)'}}>
                    <div style={{flex: 2, textAlign: 'center', fontSize: '1em', marginTop: '0.1em', fontWeight: '400', color: 'black'}}>
                        <img src="./assets/Number2.png" alt="" style={{width: '60px'}} />
                        <p style={{margin: '0.8em 0 0.2em 0', fontSize: '0.9em'}}>
                            {players[1]
                                ? players[1].pseudo.length > 14
                                    ? players[1].pseudo.slice(0, 11) + '...'
                                    : players[1].pseudo
                                : '...'}
                        </p>
                        <span style={{color: 'black', background: 'rgba(234, 228, 186, 1)', padding: '0.4em 0.6em', borderRadius: '1.8em', fontSize: '0.75em'}}>
                            {players[1] ? players[1].score : '...'} PTS
                        </span>
                    </div>
                    <div style={{flex: 2, textAlign: 'center', fontSize: '1em', marginTop: '0.1em', fontWeight: '400', color: 'black'}}>
                        <img src="./assets/Number1.png" alt=""  style={{width: '80px'}}/>
                        <p style={{margin: '0.8em 0 0.2em 0', fontSize: '0.9em'}}>
                        {players[0]
                            ? players[0].pseudo.length > 14
                                ? players[0].pseudo.slice(0, 11) + '...'
                                : players[0].pseudo
                            : '...'}
                        </p>
                        <span style={{color: 'black', background: 'rgba(255, 234, 0, 1)', padding: '0.4em 0.6em', borderRadius: '1.8em', fontSize: '0.75em'}}>
                            {players[0] ? players[0].score : '...'} PTS
                        </span>
                    </div>
                        <div style={{flex: 2, textAlign: 'center', fontSize: '1em', marginTop: '0.1em', fontWeight: '400', color: 'black'}}>
                            <img src="./assets/Number3.png" alt=""  style={{width: '60px'}}/>
                            <p style={{margin: '0.8em 0 0.2em 0', fontSize: '0.9em'}}>
                            {players[2]
                            ? players[2].pseudo.length > 14
                                ? players[2].pseudo.slice(0, 11) + '...'
                                : players[2].pseudo
                            : '...'}
                        </p>
                        <span style={{color: 'black', background: 'rgba(245, 130, 32, 1)', padding: '0.4em 0.6em', borderRadius: '1.8em', fontSize: '0.75em'}}>
                            {players[2] ? players[2].score : '...'} PTS
                        </span>
                    </div>
                </div>
                <div style={{marginTop:'1em'}}>
                {
                    players
                    .filter(player => player.pseudo.toLowerCase().includes(search.toLowerCase()))
                    .map((player, index) => {
                        return (
                            <div style={{margin: '0.3em', }} key={index}>
                                <div style={{background: 'rgba(255,255,255,0.5)', padding: '0.3em', borderRadius: '2em'}}>
                                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'self-start'}}>
                                        <div style={{width: '50px', height: '30px', borderRadius: '16px', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '1em', fontWeight: 'lighter', color: 'black', padding:'0.5em', left:'10px', top:'10px', margin:'5px 0 5px 5px'}}>
                                            {index + 1}
                                        </div>
                                        <div style={{flex: 5, textAlign: 'start', marginLeft: '0.5em', fontSize: '1em', marginTop: '0.4em', fontWeight: 'lighter', color: 'black'}}>
                                        {player.pseudo.length > 16 
                                        ? player.pseudo.slice(0, 12) + '...' 
                                        : player.pseudo}
                                        </div>
                                        <div style={{flex: 2, textAlign: 'end', marginRight: '1em', fontSize: '1em', marginTop: '0.4em', fontWeight: 'lighter', color: 'black'}}>
                                            {player.score} PTS
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
                </div>
            </div>
            <div style={{width: '100%'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100vh" viewBox="0 0 393 773" fill="none" style={{position: 'absolute', bottom: '-20vh', left: 0, pointerEvents: 'none'}}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M-341.732 0H-344V880H736V0H733.732C708.582 274.773 477.434 489.988 196 489.988C-85.4337 489.988 -316.582 274.773 -341.732 0Z" fill="#118A9B"/>
                </svg>
                <div style={{
                    position: 'absolute',
                    background: "#0C7789",
                    borderRadius: "30px", 
                    display: "flex", 
                    alignItems: "center",
                    bottom: '5%',
                    left: '5%',
                    width: '90%'
                }}>
                    <input
                        value={search}
                        onChange={(e)=>{setSearch(e.target.value)}} 
                        className="input"
                        placeholder="Enter your nickname"
                        style={{
                        border: 'none',
                        outline: 'none',
                        textAlign: 'left',
                        fontWeight: '400',
                        fontSize:'1rem',
                        background: '#0C7789',
                        color: '#ffffff',
                        padding: '0.4em 1em',
                        borderRadius: '2.6em',
                        textTransform: 'uppercase',
                        width:'90%'
                        }}
                    />
                        <div style={{
                        width: "20px", 
                        height: "20px", 
                        background: "#FFFFFF",
                        right: 0,
                        mask: "url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\"%3E%3Cpath d=\"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"%3E%3C/path%3E%3C/svg%3E') no-repeat center center", 
                        WebkitMask: "url('data:image/svg+xml,%3Csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\"%3E%3Cpath d=\"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z\"%3E%3C/path%3E%3C/svg%3E') no-repeat center center", 
                        maskSize: "contain", 
                        WebkitMaskSize: "contain"
                        }}></div>
                </div>
            </div>
        </div>
    );
}